// extracted by mini-css-extract-plugin
export default {"featureCell":"FeatureCell_featureCell__Yw9ir","featureName":"FeatureCell_featureName__Ihyml","featureDesc":"FeatureCell_featureDesc__EpqBH","title":"FeatureCell_title__cuIi9"};